import React from 'react';
import { Construction } from 'lucide-react';
import { useAuth } from '../../auth';
import { useSiteAvailability } from './SiteAvailability';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const ConstructionIndicator = () => {
  const { user } = useAuth();
  const site = useSiteAvailability();
  if (user?.role !== 'admin' || !site?.settings?.under_construction) return null;
  return <TooltipProvider delayDuration={150}><Tooltip><TooltipTrigger asChild><span className="header-construction-indicator" tabIndex={0} role="img" aria-label="Site is under construction" data-testid="header-construction-indicator"><Construction size={23} aria-hidden="true" /></span></TooltipTrigger><TooltipContent data-testid="header-construction-tooltip">Under Construction is on</TooltipContent></Tooltip></TooltipProvider>;
};